var React = require('react');

function SmallArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 7.89229C5.37934 7.86897 5.55201 8.11478 7.20806 8.00353C8.8641 7.89229 14.5102 7.86897 19.2624 7.51537M15.22 5C16.1301 5.55501 18.1961 6.79904 19.2624 7.12014C19.9764 7.33515 20.4832 7.33212 19.2624 8.18021C18.0496 9.02275 17.1443 9.947 15.3256 11","stroke":"#021546","strokeWidth":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

SmallArrowInline.defaultProps = {"width":"25","height":"16","viewBox":"0 0 25 16","fill":"none"};

module.exports = SmallArrowInline;

SmallArrowInline.default = SmallArrowInline;
